import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { APPLICATIONS } from 'constants/path';

export const useSyncApplicationRoute = (applicationId?: string | null): void => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    if (!applicationId) {
      return;
    }

    const firstPathPart = pathname.split('/')?.[1];
    const isApplicationsRoute = firstPathPart === APPLICATIONS.slice(1);

    if (isApplicationsRoute) {
      navigate(`${APPLICATIONS}/${applicationId}`);
    }

    return () => {
      if (isApplicationsRoute) {
        navigate(APPLICATIONS);
      }
    };
  }, [applicationId, navigate, pathname]);
};

